<template>
  <div>
    <v-flex class="text-md-right">
      <v-btn @click="open_dialog" color="primary" dark class="mb-2">Nuevo</v-btn>
    </v-flex>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <v-text-field v-if="name_not_editable"
                              disabled
                              v-model="editedItem.username"
                              label="Nombre">
                </v-text-field>
                <v-text-field v-else v-model="editedItem.username" label="Nombre"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-select
                  :items="roles"
                  label="Rol"
                  item-text="name"
                  v-model="editedItem.roleid"
                  item-value="id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field :type="show1 ? 'text' : 'password'"
                              v-model="editedItem.passwd"
                              label="Contraseña">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      v-bind:items="users"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.username }}</td>
        <td class="text-xs-left">{{ props.item.rolename }}</td>
        <td class="text-xs-left">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            :disabled="!props.item.can_delete"
            @click="deleteItem(props.item.id)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>

export default {
  data: () => ({
    show1: false,
    name_not_editable: false,
    dialog: false,
    headers: [
      { text: 'id', value: 'id', sortable: false },
      { text: 'Nombre', value: 'username', sortable: false },
      { text: 'Rol', value: 'role', sortable: false },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      username: '',
      roleid: '',
      passwd: '',
    },
    defaultItem: {
      id: '',
      username: '',
      roleid: '',
      passwd: '',
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Item' : 'Editar Item';
    },
    users() {
      return this.$store.getters.users;
    },
    roles() {
      return this.$store.getters.roles;
    },
  },

  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    },
  },

  created() {
    this.$store.dispatch('clear_users_action');
    this.$store.dispatch('fetch_users');
    this.$store.dispatch('clear_roles_action');
    this.$store.dispatch('fetch_roles');
    this.initialize();
  },

  methods: {
    initialize() {
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.name_not_editable = true;
      this.dialog = true;
    },

    deleteItem(item) {
      // eslint-disable-next-line
      confirm('Estás seguro de que quieres eliminar este item?') && this.deleteUser(item);
    },
    open_dialog() {
      this.name_not_editable = false;
      this.dialog = true;
    },
    deleteUser(user) {
      // this.users.splice(index, 1)
      this.$store.dispatch('deleteUser', user);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.users[this.editedIndex], this.editedItem);
        this.$store.dispatch('updateUser', this.editedItem);
      } else {
        this.$store.dispatch('register', this.editedItem);
      }
      this.close();
    },
  },
};
</script>
